








import { defineComponent } from "@vue/composition-api";
import BaseSpinner from "@/components/BaseSpinner";

export default defineComponent({
  name: "BasePage",
  props: { loading: { type: Boolean, default: false } },
  components: { BaseSpinner },
});
